import { EmailItemResponse } from "features/relatorios/typings";
import { useMemo } from "react";
import { PDFTableColumn } from "ui/components/PDF/Table";
import { View, Text, Image } from "@react-pdf/renderer";
import moment from "moment";
import eyeOffIcon from "assets/images/eye-off-outline.png";

function useRelatorioEmailPdfColumns(): PDFTableColumn<EmailItemResponse>[] {
  return useMemo(() => {
    return [
      {
        title: "Para",
        render: (original) => (
          <View>
            <Text>{original.nome}</Text>
            <Text style={{ fontSize: 8 }}>{original.email}</Text>
          </View>
        ),
      },
      {
        title: "Mensagem",
        flexGrow: 1.75,
        accessor: "assunto",
      },
      {
        title: "",
        flexGrow: 0.85,
        render: (original) => (
          <View
            style={{
              justifyContent: "center",
              textAlign: "right",
              marginVertical: "auto",
            }}
          >
            <Text style={{ fontWeight: "medium" }}>
              {original.data
                ? moment(original.data).format("DD/MM/YYYY [às] HH:mm")
                : "Não enviado"}
            </Text>
            {original.data ? (
              original.dataVisualizacao ? (
                <Text style={{ fontSize: 8 }}>
                  {moment(original.dataVisualizacao).format(
                    "[Lido em] DD/MM/YYYY [às] HH:mm"
                  )}
                </Text>
              ) : (
                <View
                  style={{
                    flexDirection: "row",
                    alignItems: "center",
                    fontSize: 8,
                    marginLeft: "auto",
                  }}
                >
                  <Image
                    src={eyeOffIcon}
                    style={{
                      width: "12px",
                      height: "8px",
                      objectFit: "contain",
                      marginRight: 4,
                    }}
                  />
                  <Text style={{ color: "#939393" }}>Não lida</Text>
                </View>
              )
            ) : null}
          </View>
        ),
      },
    ] as PDFTableColumn<EmailItemResponse>[];
  }, []);
}

export default useRelatorioEmailPdfColumns;
